export default function updateAction(state, payload) {
  return payload
}
